<template>
  <div class="login-container" :style="{width: screenWidth + 'px', height: screenHeight + 'px'}">
    <div class="box">
      <h2>{{ eventInfo ? eventInfo.eventName : "登录" }}</h2>
      <el-input style="margin-top: 20px" placeholder="请输入账号/手机号" v-model="account"/>
      <el-input style="margin-top: 10px" placeholder="请输入密码" v-model="password" show-password/>
      <div style="display: flex;flex-direction: row;justify-content: space-between;align-items: center">
        <div style="font-size: 13px" class="register_btn" @click="toHome"></div>
        <div style="font-size: 13px;" class="register_btn" @click="forgetPassword">忘记密码</div>
      </div>
      <div class="login_btn" @click="loginAction">登录</div>
      <div style="display: flex;flex-direction: row;justify-content: space-between;align-items: center">
        <div style="font-size: 13px" class="register_btn" @click="toHome">返回首页</div>
        <div style="font-size: 13px" class="register_btn" @click="toRegister">立即注册</div>
      </div>
    </div>
    <div style="position: absolute;bottom: 20px;font-size: 13px;color: white;z-index: 999">
      Copyright © 2024-2025 武术赛事报名系统
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {getCompetition, login} from "@/api";
import {Message} from "element-ui";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Login",
  data() {
    return {
      account: "",
      password: "",
      timerNum: 60,
      timer: null,
    };
  },
  computed: {
    ...mapState([
      "screenHeight",
      "screenWidth",
      "eventInfo"
    ])
  },
  methods: {
    toRegister() {
      this.$router.push({
        path: "/register"
      });
    }, toHome() {
      this.$router.push({
        path: "/"
      });
    },
    forgetPassword() {
      this.$router.push({
        path: "/forgetPassword"
      });
    },
    loginAction() {
      if (this.account.length === 0) {
        Message.error("账号不能为空!");
        return;
      }
      if (this.password.length === 0) {
        Message.error("密码不能为空!");
        return;
      }
      login({
        account: this.account,
        password: this.password,
      }).then(res => {
        if (res.data.code === 200) {
          if (res.data.result.permission === "报名用户") {
            this.$store.dispatch("setUserInfo", res.data.result);
            this.$store.dispatch("setUserLogin", true);
            window.localStorage.setItem("accessToken", res.data.result.token);
            this.$router.push({
              path: "/home"
            });
            this.$store.dispatch("setRouterInfo", {
              name: "首页",
              routeMenu: [],
              path: "/home",
            })
          }
          if (res.data.result.permission === "赛事管理员") {
            if ((res.data.result.competitionId + "") === "-1") {
              this.$store.dispatch("setUserInfo", res.data.result);
              this.$store.dispatch("setUserLogin", true);
              window.localStorage.setItem("accessToken", res.data.result.token);
              this.$store.dispatch("setEventInfo", null);
              this.$router.push({
                path: "/home"
              });
            } else {
              getCompetition(res.data.result.competitionId).then((res1) => {
                if (res1.data.code === 200) {
                  this.$store.dispatch("setUserInfo", res.data.result);
                  this.$store.dispatch("setUserLogin", true);
                  window.localStorage.setItem("accessToken", res.data.result.token);
                  this.$store.dispatch("setEventInfo", res1.data.result);
                  this.$router.push({
                    path: "/home"
                  });
                  this.$store.dispatch("setRouterInfo", {
                    name: "首页",
                    routeMenu: [],
                    path: "/home",
                  })
                } else {
                  Message.error("未关联赛事!请联系负责人!");
                }
              })
            }
          }
          if (res.data.result.permission === "超级管理员") {
            this.$store.dispatch("setUserInfo", res.data.result);
            this.$store.dispatch("setUserLogin", true);
            window.localStorage.setItem("accessToken", res.data.result.token);
            this.$router.push({
              path: "/userList"
            });
            this.$store.dispatch("setRouterInfo", {
              name: "用户列表",
              routeMenu: [],
              path: "/userList",
            })
          }
          if (res.data.result.permission === "赛事方查阅") {
            getCompetition(res.data.result.competitionId).then((res1) => {
              if (res1.data.code === 200) {
                this.$store.dispatch("setUserInfo", res.data.result);
                this.$store.dispatch("setUserLogin", true);
                window.localStorage.setItem("accessToken", res.data.result.token);
                this.$store.dispatch("setEventInfo", res1.data.result);
                this.$router.push({
                  path: "/teamList"
                });
                this.$store.dispatch("setRouterInfo", {
                  name: "代表队信息",
                  routeMenu: [],
                  path: "/teamList",
                })
              } else {
                Message.error("未关联赛事!请联系负责人!");
              }
            })
          }
        } else {
          Message.error("账号密码错误!");
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.login-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url("../assets/bg.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;


  .box {
    width: 30vw;
    max-width: 400px;
    padding: 30px;
    background-color: white;
    border-radius: 8px;
    position: relative;
    overflow: hidden;

    .login_btn {
      width: 100%;
      background-color: #1FA4FF;
      margin-top: 30px;
      height: 40px;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      cursor: pointer;
    }

    .register_btn {
      font-size: 15px;
      margin-top: 15px;
      cursor: pointer;
      color: #1FA4FF;
    }
  }
}
</style>
